import styled from 'styled-components';
import { BreakPoint, Color, Font, FontSize } from '../../asset/styles';
import { check } from '../../asset/images';

// for Thanks

export const StyledBox = styled.div`
  background-color: ${Color.white};
  border-top: solid 1px ${Color.border.green};
  box-sizing: border-box;
  color: ${Color.text.black};
  font-family: ${Font.default};
  padding: 16px;
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;

  @media (min-width: ${BreakPoint.desktop}) {
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.16);
    width: 456px;
    bottom: 32px;
    top: auto;
    left: auto;
    right: 10%;
    padding-top: 16px;
  }

  * {
    font-family: ${Font.default};
  }
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;

  @media (min-width: ${BreakPoint.desktop}) {
    border-top-left-radius: 2px;
    border-top-right-radius: 2px;
  }
`;

// check mark green - title 横に表示させます
export const StyledIcon = styled.div`
  background: url(${check.green}) no-repeat center center;
  background-size: 21px 16px;
  height: 16px;
  width: 21px;
  margin-top: 8px;

  @media (min-width: ${BreakPoint.desktop}) {
    background-size: 14px 10px;
    height: 10px;
    width: 14px;
  }
`;

export const StyledTitle = styled.div`
  color: ${Color.text.green};
  flex: 1;
  font-size: ${FontSize.medium};
  font-weight: 700;
  margin-top: 8px;
  margin-left: 16px;
  word-break: break-all;

  @media (min-width: ${BreakPoint.desktop}) {
    margin-left: 8px;
  }

  @media (max-width: ${BreakPoint.small}) {
    font-size: ${FontSize.smallDevice.medium};
  }
`;

export const StyledClose = styled.div`
  align-self: start;
  margin-left: 16px;
`;

export const StyledMessage = styled.div`
  color: ${Color.text.black};
  font-size: ${FontSize.medium};
  /*
  margin-top: 8px;
  margin-right: 36px;
  */
  margin: 8px 18px;
  word-break: break-all;

  @media (min-width: ${BreakPoint.desktop}) {
    border-bottom-left-radius: 2px;
    border-bottom-right-radius: 2px;
    margin-top: 16px;
  }
`;



// WEBPACK FOOTER //
// ./src/phase2/survey/page/thanks/style.js